/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignJustify = (
	<SVG xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 12.8h16v-1.5H4v1.5zm0 7h12.4v-1.5H4v1.5zM4 4.3v1.5h16V4.3H4z" />
	</SVG>
);

export default alignJustify;
